import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Layout from '../Layout';

// 11/03 (Josh: "can we consolidate any pages?" → "go for it"): one shell for pages that fold several older pages into
// tabs. The active tab lives in `?tab=`, so the old URLs can redirect straight onto the right tab and bookmarks keep
// working. Each tab renders an existing page in `embedded` mode (its body without the app shell).
export function useHubTab(tabs, fallback) {
  const [params, setParams] = useSearchParams();
  const wanted = params.get('tab');
  const active = tabs.some(t => t.key === wanted) ? wanted : fallback;
  const setTab = (key) => { const p = new URLSearchParams(params); p.set('tab', key); setParams(p, { replace: true }); };
  return [active, setTab];
}

export default function HubTabs({ title, subtitle, tabs, fallback, testId }) {
  const [active, setTab] = useHubTab(tabs, fallback || tabs[0].key);
  const current = tabs.find(t => t.key === active) || tabs[0];
  return (
    <Layout>
      <div className="space-y-4" data-testid={testId}>
        <div>
          <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
          {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
        </div>
        <div className="flex flex-wrap gap-1 border-b" role="tablist">
          {tabs.map(t => (
            <button key={t.key} type="button" role="tab" aria-selected={t.key === active} onClick={() => setTab(t.key)}
                    data-testid={`${testId}-tab-${t.key}`}
                    className={`px-3 py-2 text-sm -mb-px border-b-2 ${t.key === active ? 'border-blue-600 text-blue-700 font-semibold' : 'border-transparent text-slate-500 hover:text-slate-800'}`}>
              {t.label}
            </button>
          ))}
        </div>
        <div key={current.key}>{current.render()}</div>
      </div>
    </Layout>
  );
}
